import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { withStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import ShowChart from '@mui/icons-material/ShowChart';
import ThumbUpOutlined from '@mui/icons-material/ThumbUpOutlined';
import PlayArrowOutlined from '@mui/icons-material/PlayArrowOutlined';
import BarChartOutlined from '@mui/icons-material/BarChartOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import Favorite from '@mui/icons-material/Favorite';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@mui/icons-material/Clear';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';

const Text = withStyles({
  root: {
    color: '#ffffff',
    fontSize: '14px',
  },
})(Typography);

const CustomButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
}));

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

interface statusButtonProps {
  text: string;
  type: string;
  isGold?: boolean;
}

const StatusButton: React.FC<statusButtonProps> = ({ type, text, isGold }) => {
  return (
    <CustomButton>
      {type === 'chart' ? (
        <ShowChart sx={{ fontSize: '20px' }} />
      ) : type === 'finger' ? (
        <ThumbUpOutlined sx={{ fontSize: '20px', color: '#ffffff' }} />
      ) : type === 'play' ? (
        <PlayArrowOutlined sx={{ fontSize: '20px', color: '#ffffff' }} />
      ) : type === 'graph' ? (
        <BarChartOutlined sx={{ fontSize: '20px', color: '#ffffff' }} />
      ) : type === 'favor' ? (
        <Checkbox
          style={{
            padding: 'unset',
            fontSize: '20px',
            paddingBottom: '0px !important',
          }}
          {...label}
          icon={<FavoriteBorderOutlinedIcon style={{ color: '#c1c1c1' }} />}
          checkedIcon={<Favorite style={{ color: '#ddb930' }} />}
        />
      ) : type === 'camera' ? (
        <CameraAltOutlinedIcon sx={{ fontSize: '20px', color: '#ffffff' }} />
      ) : type === 'video' ? (
        <VideocamOutlinedIcon sx={{ fontSize: '20px', color: '#ffffff' }} />
      ) : type === 'money' ? (
        <AttachMoneyOutlinedIcon sx={{ fontSize: '20px', color: '#ffffff' }} />
      ) : type === 'clear' ? (
        <ClearIcon sx={{ fontSize: '20px', color: '#ffffff' }} />
      ) : type === 'lock' ? (
        <LockOutlinedIcon sx={{ fontSize: '20px', color: '#DDB930' }} />
      ) : type === 'tag' ? (
        <GroupAddOutlinedIcon sx={{ fontSize: '20px', color: '#ffffff' }} />
      ) : (
        <ChatBubbleOutlineOutlinedIcon
          sx={{ fontSize: '20px', color: '#ffffff' }}
        />
      )}
      <Text style={{ color: isGold ? '#DDB930' : '#fff' }}>{text}</Text>
    </CustomButton>
  );
};

export default StatusButton;
